import React, { useEffect, useState } from 'react';
import Image from 'antd/es/image';
import Button from 'antd/es/button';
import { Link } from 'react-router-dom';
import Modal from 'antd/es/modal/Modal';

import { useAppSelector } from 'utils/hooks';
import { getCourseSelector } from 'models/course/selectors';
import { PathCreator, RoutePaths } from 'routing/constants';
import { ModalActionsContainer, WelcomeModalContainer } from './elements';
import { ArrowRightIcon } from 'components/icons/system/arrows/arrow-right-icon';

const defaultCourseURL = '/images/default-course.png';
const transparentPixel =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

export const WelcomeModal = () => {
  const course = useAppSelector(getCourseSelector);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (course) {
      const courseFilter = course?.pos !== 'lightspeed' && course?.pos !== 'tei';
      setOpen(courseFilter && localStorage.getItem('showWelcome') !== 'False');
    }
  }, [course]);

  const onClose = () => {
    localStorage.setItem('showWelcome', 'False');
    setOpen(false);
  };

  return (
    <>
      <Modal open={open} maskClosable={false} onCancel={onClose} footer={null}>
        <WelcomeModalContainer>
          <Image alt="logo" src={course?.id ? course?.logoUrl || defaultCourseURL : transparentPixel} />

          <h2>Welcome To The New Online Booking System</h2>

          <p>
            Please <Link to={PathCreator[RoutePaths.AUTH_SIGNUP].getUrl()}>sign up</Link> to book online tee times,
            manage your reservations and get special offers
          </p>
        </WelcomeModalContainer>
        <ModalActionsContainer>
          <Button type="default" size="large" onClick={onClose} icon={<ArrowRightIcon />}>
            Continue without sign up
          </Button>
        </ModalActionsContainer>
      </Modal>
    </>
  );
};

